import { FC } from 'react';
import { Chip, SxProps } from '@mui/material';
import { CampaignStatus } from '@libs/types';

interface CampaignStatusChipProps { 
  status?: CampaignStatus | string;
  sx?: SxProps;
}

export const CampaignStatusChip: FC<CampaignStatusChipProps> = ({ status, sx }) => {
  let backgroundColor;
  let color;

  switch (status) {
    case CampaignStatus.PENDING:
      backgroundColor = 'secondary.light';
      color = 'text.primary';
      break;
    case CampaignStatus.ACTIVE:
      backgroundColor = 'success.light';
      color = 'success.contrastText';
      break;
    case CampaignStatus.PAUSED:
      backgroundColor = 'warning.main';
      color = 'warning.contrastText';
      break;
    case CampaignStatus.COMPLETED:
      backgroundColor = 'secondary.main';
      color = 'secondary.contrastText';
      break;
    case CampaignStatus.CANCELLED:
      backgroundColor = 'error.light';
      color = 'error.contrastText';
      break;
    default:
      backgroundColor = 'secondary.light';
      color = 'text.primary';
  }

  return <Chip label={status} sx={{ backgroundColor, color, ...sx }} size="small" />;
};
